import type { Message } from '@ag-ui/client';
import is from '@sindresorhus/is';

import { readAgUiAssistantMetadata } from '../data-contract/chat';

const keepEarlierTurn = (earlier: Message, later: Message): Message => {
    const turn = readAgUiAssistantMetadata(earlier.metadata);
    if (is.null(turn) || turn.assistantMessageId === readAgUiAssistantMetadata(later.metadata)?.assistantMessageId) {
        return later;
    }
    return { ...later, metadata: { ...later.metadata, cobrainer: { ...turn, status: undefined } } };
};

export const collapseToFirstTurn = (shown: readonly Message[], next: readonly Message[]): Message[] => {
    const shownById = new Map(shown.map((message) => [message.id, message]));
    const kept = new Map<string, Message>();
    for (const message of next) {
        const earlier = message.role === 'activity' ? (kept.get(message.id) ?? shownById.get(message.id)) : undefined;
        kept.set(
            message.id,
            is.undefined(earlier) || earlier === message ? message : keepEarlierTurn(earlier, message),
        );
    }
    return [...kept.values()];
};
